export class MiPlayerCreatedEvent extends Event {

  constructor () {
    super('miPlayerCreated')
  }
}
